import React from 'react';
import PropTypes from 'prop-types';

const ChooseSinksOptionGroup = ({ children }) => children.length > 0 && (
  <div className="ChooseSinksOptionGroup background-white" data-template="ChooseSinksOptionGroup">
    <div className="headless">
      {children}
    </div>
  </div>
);

ChooseSinksOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChooseSinksOptionGroup;
